import { getURLParams } from '@/helper/util';
import { userStore, webStore } from '@/store/base';
import { DeeplinkApi, CommonApi } from '@/api';

export const getUUIDFromSearchParams = (searchParams = null) => {
  if (!searchParams) {
    searchParams = getURLParams();
  }

  return searchParams.get('uuid');
};

export const parseSearchParams = async () => {
  try {
    const searchParams = getURLParams();
    const uuid = getUUIDFromSearchParams(searchParams);
    const code = searchParams.get('code');
    const appId = searchParams.get('appId');
    const platform = searchParams.get('platform');
    const mpurl = searchParams.get('mpurl');

    // code and appId are required
    if (!code || !appId || !platform) {
      throw new Error('code, appId and platform are required');
    }

    webStore.paramManager.setParams({
      platform,
    });

    await CommonApi.BFFServiceAuth.getApiKey(code, appId);

    const { data } = await DeeplinkApi.getDataByUUID(uuid);

    await userStore.setUserInfoWithToken(data.ssoInfo);
    webStore.paramManager.setParams({ openId: data.openId, bgKey: data.bgKey });

    return {
      ...data,
      mpurl,
    };
  } catch (error) {
    console.error('Failed to retrieve data by UUID:', error);
    throw error;
  }
};

export const updateSearchParams = (data) => {
  const newSearchParams = new URLSearchParams({
    locationId: data.locationId,
    locationName: data.locationName,
    totalRooms: data.totalRooms,
    adults: data.adults,
    children: data.children,
    totalAdults: data.totalAdults,
    totalChildren: data.totalChildren,
    checkin: data.checkin,
    checkout: data.checkout,
    wmpurl: data.wmpurl,
  });

  window.history.replaceState(
    {},
    '',
    `${window.location.pathname}?${newSearchParams.toString()}`,
  );
};
